import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import Counters from "pages/Presentation/sections/Counters";
import Information from "pages/Presentation/sections/Information";
import EquipamentosMaquinas from "pages/Presentation/sections/EquipamentosMaquinas"
import Parceiros from "./sections/parceiros";
import bgImage from "assets/images/bg-presentation.jpg";
import BannerCarousel from "./components/BannerCarousel/BannerCarousel";
import IdentityBar from "./sections/IdentityBar";
import WhatsAppFloat from "components/WhatsAppFloat";
import { Divider } from "@mui/material";

function Presentation() {
  return (
    <>
      <MKBox
        minHeight="68vh"
        width="100%"
        sx={{
          backgroundImage: `linear-gradient(
      rgba(30, 30, 30, 0.8), 
      rgba(30, 30, 30, 0.8)
    ), url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <BannerCarousel />
      </MKBox>

      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <IdentityBar as="h1" />
        <Counters />
         <Divider
                sx={{
                    mt: { xs: 4, md: 6 },
                    height: 2,
                    border: "none",
                    background:
                        "linear-gradient(90deg, rgba(3,109,61,0) 0%, rgba(3,109,61,.35) 25%, rgba(3,109,61,.5) 50%, rgba(3,109,61,.35) 75%, rgba(3,109,61,0) 100%)",
                }}
            />


        <Information />
        
        <Parceiros />
        <Container>
        <EquipamentosMaquinas />
        </Container>
      
      </Card>
        <WhatsAppFloat />
    </>
  );
}

export default Presentation;
